import React from "react"

export type TBlobContextItem = {
  id: string
  blob: Blob
  imageUrl?: string
}

export const BlobContext = React.createContext({
  blobList: [] as Array<TBlobContextItem>,
  addBlobItem: (newItem: TBlobContextItem): void => {},
  removeBlobItem: (targetId: string): void => {},
})

/**
 * 車輛マスタのProvider
 */
export const SyaryoMasterRegisterProvider: React.FC<{
  blobList: Array<TBlobContextItem>
  addBlobItem: (newItem: TBlobContextItem) => void
  removeBlobItem: (targetId: string) => void
}> = (props) => {
  return (
    <BlobContext.Provider
      value={{
        blobList: props.blobList,
        addBlobItem: props.addBlobItem,
        removeBlobItem: props.removeBlobItem,
      }}>
      {props.children}
    </BlobContext.Provider>
  )
}
